export default "__VITE_PUBLIC_ASSET__62c1a779__"